var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"videoPlayerDialog","no-close-on-backdrop":"","hide-header":"","ok-only":"","ok-title":"Close"}},[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":_vm.url,"allowfullscreen":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }